<template lang="html">
  <div class="">
    <div class="margin-top-20">
      <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
        <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
          You have only view permission.
      </div>
      <div :disabled="!ifTeamleaderAnchorPermission">
        <data-table :columns="payGroupDataColumns" :tableData="acknowledgementsData" :checkbox="false" :withForm="false" :showinrow="true"
          :showedit="false" :showhistory="false" @delete="deleteItem">
          <template v-slot:rowcontent="slotprops">
            <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"
            />
            <p v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key!='LegalEntityForm24Q'  && slotprops.value.column.key !='attachments' && slotprops.value.column.key !='fileType'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <div v-if="slotprops.value.column.key=='attachments'">
                <img v-if="" class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                <a class="file-name input-label attachment" :href="slotprops.value.record[slotprops.value.column.key]" target="blank" download=true>
                  Document</a>
            </div>
            <div v-if="slotprops.value.column.key=='fileType'">
              <span>
                <label class="file-type-label">
                  {{slotprops.value.record[slotprops.value.column.key]}}
                </label>
              </span>
            </div>
            <div v-if="slotprops.value.column.key=='LegalEntityForm24Q'">
              <p>{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key].quarter : ""}}</p>
            </div>
          </template>
        </data-table>
      </div>
    </div>

    <pop-up-message
      v-if="showConfirmDelete"
      :message="'Are you sure you wish to delete ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"

    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancelEvent()"
          >Cancel</button>
          <button class="btn-popup" type="button" @click="confirmDelete()">Delete</button>
        </div>
      </template>
    </pop-up-message>


  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "acknowledgementHistory",
  computed: {
    ...mapState({}),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
      ...mapState("onboard/organization", {
        orgIds: state => state.id
      }),
      ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.updateForm24qAcknowledgementValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        //   return true 
        // }
      }
  },
  data() {
    return {
      showConfirmDelete: false,
      popupType: "ConfirmDelete",
      currentObj: {},
      toast: false,
      errmsg: "",
      payGroupData: [
        {
          id: 1,
          quarters: "Q 1",
          acknowledgementNumber: "ack 11bgd3",
          prnNumber: "214675",
          fromMonth: "April",
          toMonth: "June",
          file_location: [{ filename: "atch1.png" }],
          filingDate: "21 June 2019",
          fileType: ""
        },
        {
          id: 2,
          quarters: "Q 1",
          acknowledgementNumber: "ack 11bgd3",
          prnNumber: "214675",
          fromMonth: "April",
          toMonth: "June",
          file_location: [{ filename: "atch1.png" }],
          filingDate: "21 June 2019",
          fileType: "Original"
        },
        {
          id: 3,
          quarters: "Q 1",
          acknowledgementNumber: "ack 11bgd3",
          prnNumber: "214675",
          fromMonth: "April",
          toMonth: "June",
          file_location: [{ filename: "atch1.png" }],
          filingDate: "21 June 2019",
          fileType: ""
        },
        {
          id: 4,
          quarters: "Q 1",
          acknowledgementNumber: "ack 11bgd3",
          prnNumber: "214675",
          fromMonth: "April",
          toMonth: "June",
          file_location: [],
          filingDate: "21 June 2019",
          fileType: ""
        }
      ],
      payGroupDataColumns: [
        {
          label: "Quarters",
          key: "quarter_name"
        },
        {
          label: "From Month",
          key: "fromMonth"
        },
        {
          label: "To Month",
          key: "toMonth"
        },
        {
          label: "Acknowledgement Number",
          key: "acknowledgement_no"
        },
        {
          label: "Filing Date",
          key: "filling_date"
        },
        {
          label: "Attachements",
          key: "attachments"
        },
        {
          label: "",
          key: "file_type"
        }
      ],
      acknowledgementsData: [],
      updateForm24qAcknowledgementValue: false,
      role: ""
    };
  },
  mounted() {
     this.fetchAcknowledgements();
    this.getOrgLeIdList();
  },

  activated() {
   this.fetchAcknowledgements();
    this.getOrgLeIdList();
  },

  methods: {
    ...mapActions({
      fetchAll:
        "dashboard/organisation/utilities/form24Qacknowledgement/fetchAll",
      act_delete:
        "dashboard/organisation/utilities/form24Qacknowledgement/delete"
    }),

    async fetchAcknowledgements() {
      try {
        let res = await this.fetchAll(this.le_id);
        //console.log("fetchAcknowledgementListByHistory:", res);
        if (res.status == 200) {
          this.acknowledgementsData = res.data.payload.data;
        }
      } catch (error) {
        //console.log("error", error);
        this.toast = true;
        this.errmsg = error;
      }
    },

    deleteItem(item) {
      //console.log("Delete", item);
      this.showConfirmDelete = true;
      this.currentObj = item;
    },

    cancelEvent() {
      this.showConfirmDelete = false;
    },

    confirmDelete() {
      this.deleteEvent();
    },

    async deleteEvent() {
      try {
        let res = await this.act_delete(this.currentObj);
        //console.log("res", res);
        if (res.status == 200) {
          this.fetchAcknowledgements();
        }
        this.showConfirmDelete = false;
      } catch (err) {
        //console.log("error msg", err.message);
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgIds;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.updateForm24qAcknowledgementValue = data.data.user.permissions.update_form_24q_acknowledgement ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.margin-top-20 {
  margin-top: 20px;
}

.attachment {
  font-size: 14px;
  margin-left: 20px;
  margin-top: -24px;
}

.row-item {
  padding: 6px 8px;
}

.file-type-label {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  color: #5d409f;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
